import colors from "./colors";
import pxToRem from "../functions/pxToRem";
import tokens from "../tokens";

const { grey } = colors;

const borders = {
  borderColor: grey[300],

  borderWidth: {
    0: 0,
    1: pxToRem(1),
    2: pxToRem(2),
    3: pxToRem(3),
    4: pxToRem(4),
    5: pxToRem(5),
  },

  borderRadius: {
    xs: pxToRem(1.6),
    sm: pxToRem(2),
    md: pxToRem(tokens.radius.sm),
    lg: pxToRem(tokens.radius.md),
    xl: pxToRem(tokens.radius.lg),
    xxl: pxToRem(tokens.radius.lg),
    section: pxToRem(160),
  },
};

export default borders;
